<div class="row">

    <div class="col-md-12">

        <div class="app-page">
             <!-- <div #map1 [id]="'map-' + randomNumber" (click)="showBiggerMap()"  data-toggle="modal" data-target="#myModal" class="map-canvas height-200"></div> -->
         <a [id]="randomNumber" (click)="showBiggerMap()"  data-toggle="modal" data-target="#myModal" > 
            <img style="cursor: pointer;height: 20px;width: 30px;margin-top: 10px;" src="assets/visibility.png" alt="View Route Map" />
        </a> 
        </div>
    </div>
</div>

<!--modal-->
<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <h5 class="modal-title" id="myModalTitle">Route Description - {{title}}</h5>
                <button type="button" class="close white-text" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="app-page mt-lg-3">
                    <div #map2 [id]="'map-' + randomNumber2" class="map-canvas height-800"></div>
                </div>
            </div>
        </div>
    </div>
</div>
